import { TypeArea, TypeJobAdvert } from 'generated/contentful';

import SimilarJob from './SimilarJob';

interface SimilarJobListProps {
  job: TypeJobAdvert<'WITHOUT_UNRESOLVABLE_LINKS', string>;
  areas: TypeArea<'WITHOUT_UNRESOLVABLE_LINKS', string>[];
}

export default function SimilarJobList({ job, areas }: SimilarJobListProps) {
  return (
    <>
      {areas.map((area, index) => {
        return <SimilarJob job={job} area={area} key={index} />;
      })}
    </>
  );
}
